<template>

  <div class="help-panels">

    <v-expansion-panels tile>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.myOrders.howToCancelOrder.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.myOrders.howToCancelOrder.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>


  </div>


</template>

<script>

export default {
  name: 'MyOrdersHelp',
  props: {
  },
  data () {
    return {
    }
  },
}
</script>


<style scoped>

</style>
